// extracted by mini-css-extract-plugin
module.exports = {"navigationMenu":"Navigationmenu_navigationMenu__2o7xy"};